<form>
  <div class="flex">
    <fcom-text-input
      data-test-additional-email
      class="block ms-xsmall-t flex-1"
      [parentForm]="parentForm"
      [displayMargin]="false"
      [translationPrefix]="controlName"
      [controlName]="controlName"
      [placeHolder]="parentForm.get(controlName).valid ? placeholder : disabledPlaceholder"
      [displayMargin]="false"
    ></fcom-text-input>
    <fcom-button
      class="add-button flex--self-end ms-small-l ms-xxsmall-b"
      [text]="buttonText | finLocalization"
      [loading]="isLoading"
      [disabled]="!parentForm.get(controlName).valid || !parentForm.get(controlName).value"
      (click)="addEmail.emit()"
      [type]="ButtonType.SUBMIT"
    >
    </fcom-button>
  </div>
</form>
<div class="chip-wrapper flex flex--wrap flex--start ms-small-t">
  <fcom-chip-button
    *ngFor="let email of emailsArray; let i = index"
    [title]="email"
    [text]="email"
    [disabled]="isLoading"
    [iconName]="'close-delete'"
    (chipClicked)="removeEmail.emit(i)"
  >
  </fcom-chip-button>
</div>
